import styled from "styled-components";

const Field = styled.div`
	width: 130px;
	display: flex;
	align-items: center;
`;

export default Field;
